import { render, staticRenderFns } from "./CustomersMain.vue?vue&type=template&id=66763f00&scoped=true&"
import script from "./CustomersMain.vue?vue&type=script&lang=js&"
export * from "./CustomersMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66763f00",
  null
  
)

export default component.exports